import { ReactNode } from 'react';
import {
  Box,
  Container,
} from '@mui/material';

interface DemoSectionProps {
  children: ReactNode;
  backgroundColor?: string;
  minHeight?: string;
  className?: string;
}

/**
 * Reusable wrapper component for demo sections with consistent styling
 */
export default function DemoSection({ 
  children, 
  backgroundColor = '#f5f5f5', 
  minHeight = '100vh',
  className 
}: DemoSectionProps) {
  return (
    <Box
      className={className}
      sx={{
        backgroundColor,
        py: { xs: 4, md: 8 },
        px: { xs: 2, sm: 3, md: 4 },
        minHeight,
        overflow: 'hidden', // Prevent horizontal scrolling
      }}
    >
      <Container 
        maxWidth="lg" 
        sx={{ 
          px: { xs: 1, sm: 2, md: 3 },
          maxWidth: '100%', // Ensure container never exceeds viewport width
        }}
      >
        {children}
      </Container>
    </Box>
  );
}
